import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_LIST,
  ACTION_UPDATE,
} from "models/role/action";
import {
  SUBJECT_CASH_MANAGEMENT_SETTLEMENT_NOTIFICATION,
  SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
  SUBJECT_CREDIT_NOTIFICATION_PREFERENCES,
  SUBJECT_PAYOUTS_NOTIFICATIONS,
} from "models/role/subject";
import { lazyRetryWithPreload } from "utils/lazyRetryWithPreload";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const Configuration = lazyRetryWithPreload(
  () => import("../pages/Configuration"),
  "Configuration"
);

const Accounts = lazyRetryWithPreload(
  () => import("../pages/Accounts"),
  "Accounts"
);

const Beneficiaries = lazyRetryWithPreload(
  () => import("../pages/Beneficiaries"),
  "Beneficiaries"
);

const CreateTrustedBeneficiary = lazyRetryWithPreload(
  () => import("../pages/CreateTrustedBeneficiary"),
  "CreateTrustedBeneficiary"
);

const UpdateTrustedBeneficiary = lazyRetryWithPreload(
  () => import("../pages/UpdateTrustedBeneficiary"),
  "UpdateTrustedBeneficiary"
);

const BeneficiaryDetails = lazyRetryWithPreload(
  () => import("../pages/BeneficiaryDetails"),
  "BeneficiaryDetails"
);

const AccountDetails = lazyRetryWithPreload(
  () => import("../pages/AccountDetails"),
  "AccountDetails"
);

export const voltAccountsRoutes: Route[] = [
  {
    title: COMMON_TRANSLATION_KEYS.configuration,
    path: PAGE_URLS.configuration,
    component: Configuration,
    showChildrenInSidebar: false,
    can: {
      or: [
        {
          do: ACTION_LIST,
          on: SUBJECT_CREDIT_NOTIFICATION_PREFERENCES,
        },
        {
          do: ACTION_LIST,
          on: SUBJECT_PAYOUTS_NOTIFICATIONS,
        },
        {
          do: ACTION_LIST,
          on: SUBJECT_CASH_MANAGEMENT_SETTLEMENT_NOTIFICATION,
        },
      ],
    },
  },
  {
    path: PAGE_URLS.beneficiaries,
    component: Beneficiaries,
    showChildrenInSidebar: false,
    title: COMMON_TRANSLATION_KEYS.beneficiaries,
    can: {
      do: ACTION_LIST,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
    hasNestedSwitch: true,
    children: [
      {
        path: PAGE_URLS.createTrustedBeneficiary,
        component: CreateTrustedBeneficiary,
        can: {
          do: ACTION_CREATE,
          on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
        },
      },
      {
        path: PAGE_URLS.updateTrustedBeneficiary,
        component: UpdateTrustedBeneficiary,
        can: {
          do: ACTION_UPDATE,
          on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
        },
      },
      {
        path: PAGE_URLS.merchantBeneficiaryDetails,
        component: BeneficiaryDetails,
        can: {
          do: ACTION_DETAILS,
          on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
        },
      },
      {
        path: PAGE_URLS.namedAccountsBeneficiaryDetails,
        component: BeneficiaryDetails,
        can: {
          do: ACTION_DETAILS,
          on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
        },
      },
    ],
  },
  {
    path: PAGE_URLS.accounts,
    component: Accounts,
    showChildrenInSidebar: false,
    hasNestedSwitch: true,
    title: COMMON_TRANSLATION_KEYS.accountsSidebarTitle,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
    children: [
      {
        path: PAGE_URLS.voltAccountDetails,
        component: AccountDetails,
        can: {
          do: ACTION_DETAILS,
          on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
        },
      },
    ],
  },
];
